import React, { useState, useContext, useEffect } from "react";
import { Button, Paper, Typography, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, IconButton, Box } from "@mui/material";
import { isEmpty } from "lodash";
import { Stack } from "@mui/system";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";

import { isAccess, simpleMessage } from "../../../helpers/Helpers";
import { getClientReferencesAsync, deleteClientReferenceAsync } from "../../../api/Clients";
import NoData from "../../../components/NoData";
import { PaginationComponent } from "../../../components/PaginationComponent";
import SmallModal from "../../../components/modals/SmallModal";
import AddReference from "./referenceComponents/AddReference";
import EditReference from "./referenceComponents/EditReference";
import Swal from "sweetalert2";

const ClientReferences = ({ id }) => {
  const token = getToken();
  const [referenceList, setReferenceList] = useState([]);
  const [selectedReference, setSelectedReference] = useState([]);

  const [localReload, setLocalReload] = useState(false);

  const { setIsLoading, setIsUnautorized, access } = useContext(DataContext);

  const [searchTerm] = useState("");

  const withSearch = referenceList.filter((val) => {
    if (searchTerm === "") {
      return val;
    } else if (val.fullName.toString().includes(searchTerm)) {
      return val;
    }
    return false;
  });

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getClientReferencesAsync(token, id);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }
      setIsLoading(false);
      setReferenceList(result.data.result);
    })();
  }, [localReload]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = withSearch.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [addReferenceModal, setAddReferenceModal] = useState(false);
  const [editReferenceModal, seteditReferenceModal] = useState(false);

  const deleteReference = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "No podras revertir esto...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#2979ff",
      cancelButtonColor: "#f50057",

      confirmButtonText: "Eliminar!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await deleteClientReferenceAsync(token, item.id);
          if (!result.statusResponse) {
            simpleMessage(result.error.response.data.message, "error");
            return;
          }

          if (result.error === "Unauthorized") {
            setIsLoading(false);
            setIsUnautorized(true);
            return;
          }
          setIsLoading(false);
          setLocalReload(!localReload);

          Swal.fire("Eliminada!", "Referencia Eliminada.", "success");
        })();
      }
    });
  };

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 20px",
            borderBottom: "1px solid",
            borderColor: "divider",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <Typography sx={{ fontSize: 15, fontWeight: 600 }}>Referencias personales</Typography>

          {isAccess(access, "CLIENTS CREATE") ? (
            <Button onClick={() => setAddReferenceModal(true)} variant="contained" color="primary" size="small" startIcon={<AddRoundedIcon sx={{ fontSize: 17 }} />}>
              Agregar
            </Button>
          ) : null}
        </Box>

        {isEmpty(currentItem) ? (
          <NoData />
        ) : (
          <Stack spacing={0}>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table size="small" sx={{ minWidth: 640 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Dirección</TableCell>
                    <TableCell>Parentesco</TableCell>
                    <TableCell align="center">Teléfono</TableCell>
                    {isAccess(access, "CLIENTS UPDATE") || isAccess(access, "CLIENTS DELETE") ? <TableCell align="center">Acc.</TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItem.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell sx={{ fontWeight: 500 }}>{row.fullName}</TableCell>
                      <TableCell sx={{ fontSize: 12.5 }}>{row.direccion}</TableCell>
                      <TableCell sx={{ fontSize: 12.5 }}>{row.parentesco}</TableCell>
                      <TableCell align="center" sx={{ fontSize: 12.5 }}>
                        {row.telefono}
                      </TableCell>
                      {isAccess(access, "CLIENTS UPDATE") || isAccess(access, "CLIENTS DELETE") ? (
                        <TableCell align="center">
                          <Stack direction={"row"} spacing={0.5} justifyContent="center">
                            {isAccess(access, "CLIENTS UPDATE") ? (
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setSelectedReference(row);
                                  seteditReferenceModal(true);
                                }}
                              >
                                <EditRoundedIcon sx={{ fontSize: 17 }} />
                              </IconButton>
                            ) : null}
                            {isAccess(access, "CLIENTS DELETE") ? (
                              <IconButton size="small" sx={{ color: "error.main" }} onClick={() => deleteReference(row)}>
                                <DeleteRoundedIcon sx={{ fontSize: 17 }} />
                              </IconButton>
                            ) : null}
                          </Stack>
                        </TableCell>
                      ) : null}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ padding: "10px 20px 14px" }}>
              <PaginationComponent data={withSearch} paginate={paginate} itemsperPage={itemsperPage} />
            </Box>
          </Stack>
        )}
      </Paper>

      <SmallModal titulo={"Agregar Referencia"} isVisible={addReferenceModal} setVisible={setAddReferenceModal}>
        <AddReference setShowModal={setAddReferenceModal} clientId={id} localReload={localReload} setLocalReload={setLocalReload} />
      </SmallModal>

      <SmallModal titulo={"Editar Referencia"} isVisible={editReferenceModal} setVisible={seteditReferenceModal}>
        <EditReference
          setShowModal={seteditReferenceModal}
          selectedReference={selectedReference}
          setSelectedReference={setSelectedReference}
          localReload={localReload}
          setLocalReload={localReload}
        />
      </SmallModal>
    </div>
  );
};

export default ClientReferences;
